<template>
  <div class="login">
    <div class="pb-3 login-admin-logo">
      <img src="@/assets/images/AdminLOGO.svg" alt="logo" />
    </div>
    <div class="card login-card">
      <div class="card-body p-4">
        <form @submit.prevent="submitForm">
          <div class="mb-3">
            <label for="loginEmail1" class="form-label">帳號</label>
            <input
              v-model="form.email"
              type="email"
              class="form-control border rounded-pill"
              :class="{ 'is-invalid': errMsg && errMsg.auth }"
              id="loginEmail1"
              placeholder="請輸入信箱"
              required
            />
          </div>
          <div>
            <label for="loginPassword" class="form-label">密碼</label>
            <div
              class="input-group border rounded-pill"
              :class="{ 'is-invalid': errMsg && errMsg.auth }"
            >
              <input
                v-model="form.password"
                :type="show_password ? 'text' : 'password'"
                class="form-control border-0 rounded-pill"
                :class="{ 'is-invalid': errMsg && errMsg.auth }"
                id="loginPassword"
                placeholder="請輸入密碼"
                required
              />
              <span
                class="input-group-text show-password rounded-pill"
                role="button"
                @click="showedPassword"
              >
                <i
                  class="bi"
                  :class="show_password ? 'bi-eye-slash-fill' : 'bi-eye-fill'"
                ></i>
              </span>
            </div>
          </div>
          <div class="text-end mb-3">
            <router-link
              :to="{ name: 'ForgotPassword' }"
              class="btn btn-link login-forgot-password"
              >忘記密碼?</router-link
            >
          </div>
          <div class="text-danger text-center mb-3" v-if="errMsg">
            {{ errMsgInfo }}
          </div>
          <button type="submit" class="btn btn-info rounded-pill login-submit">
            登入
          </button>
        </form>
      </div>
    </div>
    <small class="pt-3 d-block text-center fw-light">
      Client： <span class="text-primary">{{ clientName }}</span>
      <span class="ps-3">
        Version： <span class="text-primary">{{ version }}</span>
      </span>
    </small>
    <small class="p-3 d-block text-center fw-light"
      >© 2021 - {{ new Date().getFullYear() }} 釦釘資訊工作室 All rights
      reserved.</small
    >
  </div>
</template>

<script>
import { auth } from '@/http/api/auth.js'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      version: process.env.PACKAGE_VERSION,
      form: {
        email: null,
        password: null
      },
      show_password: false
    }
  },
  computed: {
    ...mapState(['userInfo', 'errMsg', 'errMsgKey']),
    ...mapGetters(['clientName', 'errMsgInfo'])
  },
  watch: {
    form: {
      handler () {
        this.ClearErrMsg()
      },
      deep: true
    }
  },
  created () {
    this.SetErrMsgKey({
      auth: '登入'
    })
  },
  methods: {
    ...mapMutations([
      'GetToken',
      'Loaded',
      'Loading',
      'SetErrMsgKey',
      'SetErrMsg',
      'ClearErrMsg'
    ]),
    showedPassword () {
      this.show_password = !this.show_password
    },
    submitForm () {
      const vm = this
      vm.Loading()
      auth
        .login(vm.form)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            localStorage.setItem('codingIt_admin_token', data.token)
            vm.GetToken()
            vm.$router.push({ name: 'Website' })
          } else {
            vm.SetErrMsg(data.errMsg)
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.Loaded()
        })
    }
  }
}
</script>

<style lang="scss">
.login {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  &-admin-logo {
    width: 150px;
    margin: auto;
    img {
      width: 100%;
    }
  }
  &-coding-it-logo {
    width: 150px;
    margin: 20px auto;
    img {
      width: 100%;
    }
  }
  &-forgot-password {
    text-decoration: none;
    font-size: 14px;
    padding-right: 0;
  }
  &-card {
    max-width: 360px;
    width: 90%;
    margin: auto;
  }
  &-submit {
    width: 100%;
    color: #fff;
    transition: box-shadow 0.3s ease-in-out;
    background: $linear-gradient;
    box-shadow: 0px 4px 4px $shadow-color;
    &:hover {
      color: #fff;
      box-shadow: 0px 7px 7px $shadow-color;
    }
  }
  .show-password {
    background-color: #fff;
    border: none;
    color: $gray;
  }
}
</style>
